import $ from 'cash-dom';
import prequalifySpinner from '../prequalify-spinner';
import Popup from '../../../../components/popup';
import UnclosablePopup from '../../../../components/unclosable-popup';
import QuestionStorageBuilder from '../storage/QuestionStorageBuilder';
import QuestionInfoGetter from '../QuestionInfoGetter';
import PpcFilter from '../../filter/PpcFilter';
import makeStyleableSelects from '../../../../widgets/styleable-selects';
import Utils from '../../../../components/Utils';
import UrlHelper from '../../../../components/UrlHelper';
import PrequalState from '../PrequalState';

const APPLY_FILTER_SELECTOR = '.btn.apply';

/**
 * Handles PrequalifyModal of all questions (first and next).
 */
class PrequalifyModalHandler {
	/**
	 * @param {QuestionStorage} questionStorage Properly init PrequalifyStorage instance.
	 */
	constructor(questionStorage) {
		/** @type {Popup|UnclosablePopup} */
		this._popup = questionStorage.showCloseButton ? new Popup() : new UnclosablePopup();
		this._questionStorage = questionStorage;
		this._step_0_eventWasSent = false;
		this._redirectLink = null;
		this._prequelId = questionStorage.prequelId;

		this._popup.onPopupHide(() => {
			this._triggerPrequalHide();
		});
	}

	handle() {
		const self = this;
		let autoFilterApplied = false;

		if (!self._questionStorage.isEmpty()) {
			self._applyFilters(null, true);
			autoFilterApplied = true;

			if (self._questionStorage.redirectSourcePageId) {
				self._hideSpinnerAndPopup();
				return false;
			}
		}

		if (!self._questionStorage.question) {
			self._hideSpinnerAndPopup();
			return false;
		}

		QuestionInfoGetter.getShowPrequalifyModal(
			self._questionStorage.questionsOwnerPageId,
			self._questionStorage.question,
			function (error, response) {
			prequalifySpinner.hide();

			if (error) {
				self._handleError(error);
			} else if (response && response.show === false) {
				self._questionStorage.clearAllForQuestionsOfOwnerPageIdAsync();
				PrequalState.getInstance().noPrequal = true;
			} else if (response && response.notFound === true) {
				// probably, questions were deleted
				self._questionStorage.removeFromStorage();
				PrequalState.getInstance().noPrequal = true;
			} else if (response && response.showCurrentQuestion === false) {
				// means, the current question is empty, so, do nothing
			} else {
				self._startHandling(autoFilterApplied);
			}
		});

		return true;
	}

	_handleError(error) {
		this._hideSpinnerAndPopup();
		// TODO notify the backend about the error
	}

	_hideSpinnerAndPopup() {
		prequalifySpinner.hide();
		this._hidePopup();
	}

	_showPopup(questionContent) {
		const mandatoryPrequel = this._questionStorage.mandatoryPrequel;
		const mandatoryPrequelClass = mandatoryPrequel ? ' mandatory-prequel' : '';

		if (mandatoryPrequel) {
			$('body').css("pointer-events", "none");
		}

		this._popup.show(questionContent, 'ppc-prequal-popup' + mandatoryPrequelClass);

		$(document).trigger('PrequalifyModalHandler:showPopup');
	}

	_hidePopup() {
		this._popup.hide();
		this._triggerPrequalHide();
	}

	_triggerPrequalHide() {
		$(document).trigger('PrequalifyModalHandler:prequalHide');
	}

	_startHandling(autoFilterApplied = false) {
		if (this._questionStorage.isQuestionDone() && !autoFilterApplied) {
			this._applyFilters(function () {
				prequalifySpinner.hide();
			}, true);
		} else if (!this._questionStorage.isQuestionDone()) {
			this._handleCurrentQuestion();
		}
	}

	_handleCurrentQuestion() {
		const self = this;
		prequalifySpinner.show();

		QuestionInfoGetter.getQuestionContent(
			self._questionStorage.questionsOwnerPageId,
			self._questionStorage.question,
			function (questionContent) {
				prequalifySpinner.hide();

				if (questionContent) {
					self._showPopup(questionContent);
					makeStyleableSelects();
					self._attachButtonsClicks();
					self._sendPrequal_step_0_BIEvent(self._questionStorage.question);
				} else {
					const errMsg = 'getQuestionContent error, questionsOwnerPageId ' + self._questionStorage.questionsOwnerPageId
						+ ', question ' + self._questionStorage.question;
					self._handleError(new Error(errMsg));
				}
			}
		);
	}

	_attachButtonsClicks() {
		const self = this;

		const $popupContent = self._popup.findContent();
		// TODO make code refactor: use $(document).on('click', 'selector', ...) instead

		$popupContent.find('.go-back-button').on('click', function (e) {
			e.preventDefault();
			self._goToPrevQuestion();
		});

		$popupContent.find('.type-link').on('click', function (e) {
			e.preventDefault();
			const $button = $(this);

			const link = $button.data('link');
			const pageId = $button.data('page-id');
			const answer = $button.data('answer-id');
			const step = $button.data('current-step');
			let nextQuestion = $button.data('next-question');
			nextQuestion = nextQuestion ? nextQuestion : null;

			const filters = self._getFiltersFromElement($button);
			self._questionStorage.addFilters(filters);

			if (+$('body').data('post-id') === +pageId) {
				self._sendPrequalAnswerBIEvent(self._questionStorage.question, answer, step);
				self._goToNextQuestion(nextQuestion);
			} else if (link && pageId) {
				self._sendPrequalAnswerBIEvent(self._questionStorage.question, answer, step);

				QuestionStorageBuilder.buildByPageIdAndDataForQuestion(pageId, self._questionStorage, nextQuestion);

				self._redirectLink = link;

				self._goToNextQuestion(nextQuestion);
			}
		});

		$popupContent.find('.type-filter').on('click', function (e) {
			e.preventDefault();

			const $button = $(this);
			const answer = $button.data('answer-id');
			const step = $button.data('current-step');
			const nextQuestion = $button.data('next-question');
			const link = $button.data('link');

			const filters = self._getFiltersFromElement($button);
			self._questionStorage.addFilters(filters);

			// Hardcode for SelectQuote vendor on US Life
			if (document.body.classList.contains('set-sub5-for-us-life') && Object.keys(filters).length > 0
				&& Object.keys(filters)[0] === 'what-is-your-annual-income') {
				Utils.addHardcodedSubIdToLinks(answer, 769);
			}

			self._redirectLink = link;

			// Hardcoded according to FIN-1618
			if (self._questionStorage._filters['credit-score'] === "poor-350-629" && self._questionStorage._filters['own-a-home'] === "no") {
				if (self._prequelId === 18) {
					self._redirectLink = "https://www.vpns.com/top/personal-loans/bad-credit/mob/";
				} else if (self._prequelId === 16) {
					self._redirectLink = "https://www.vpns.com/top/personal-loans/bad-credit/desk/";
				}
			}

			self._sendPrequalAnswerBIEvent(self._questionStorage.question, answer, step);
			self._goToNextQuestion(nextQuestion);
		});

		const $apply = $popupContent.find(APPLY_FILTER_SELECTOR);
		$apply.on('click', function (e) {
			e.preventDefault();

			if (!$apply.hasClass('readonly')) {
				self._goToNextQuestion(null);
			}
		});
	}

	_applyFilters(doneCallback, autoFilter) {
		const filters = PpcFilter.getInstance().sortAndGetFiltersWithRedirectInLastPosition(this._questionStorage.filters);

		setTimeout(() => {
			// in setTimeout 0, to be sure that styleable-selects is init
			for (const filterName in filters) {
				const filterValue = filters[filterName];
				PpcFilter.getInstance().setValue({filterName, filterValue, autoFilter});
			}

			if (typeof doneCallback === 'function') {
				doneCallback();
			}

			this._hidePodiumIfNeeded();

			setTimeout(function () {
				$(document).trigger('PrequalifyModalHandler:prequalFilterApply');
			}, 0);
		}, 0);
	}

	_getFiltersFromElement($element) {
		$element = $($element);

		const filtersData = $element.data('filters');
		const filters = Utils.get(filtersData, 'filters', {});
		let filtersToReturn = filters;

		const vendors = Utils.get(filtersData, 'vendors');
		const opeId = Utils.get(filtersData, 'opeId');

		if (vendors && opeId) {
			filtersToReturn = {};

			for (const [filterName, filterValue] of Object.entries(filters)) {
				filtersToReturn[filterName] = {val: filterValue, vendors, opeId};
			}
		}

		return filtersToReturn;
	}

	_goToNextQuestion(nextQuestion) {
		if (nextQuestion) {
			this._questionStorage.addPrevQuestion(this._questionStorage.question);

			this._questionStorage = QuestionStorageBuilder.buildByPageIdAndDataForQuestion(
				this._questionStorage.pageId, this._questionStorage, nextQuestion
			);
			this._handleCurrentQuestion();
		} else {
			this._handleLastQuestion();
		}
	}

	_showArtificialAnimation() {
		const $content = this._popup.findContent();
		if (!$content.length) {
			return null;
		}

		const $template = $('#artificial_spinner_template');
		if (!$template.length) {
			return null;
		}

		$content.children().addClass('hidden');

		const $anim = $template.html();

		$content.append($anim);

		return $anim;
	}

	_handleLastQuestion() {
		const hasArtificialSpinner = $('#artificial_spinner_template').length > 0;

		const redirectWithParam = () => {
			window.location.href = UrlHelper.addParam(
				this._redirectLink,
				PrequalState.PARAM_REDIRECT_SOURCE_PAGE,
				this._questionStorage.pageId
			);
		};

		if (this._redirectLink) {
			this._questionStorage.setIsQuestionDone();

			if (hasArtificialSpinner) {
				this._showArtificialAnimation();

				setTimeout(() => {
					redirectWithParam();
				}, 2500);

				return;
			}

			redirectWithParam();
			return;
		}


		if (hasArtificialSpinner) {
			this._showArtificialAnimation();

			setTimeout(() => {
				PpcFilter.getInstance().setIsPrequal(true);
				this._applyFilters(() => {});

				this._hidePopup();
				this._questionStorage.setIsQuestionDone();
				$('body').css('pointer-events', 'auto');
			}, 2500);

			return;
		}

		$('body').css('pointer-events', 'auto');

		prequalifySpinner.show();

		setTimeout(() => {
			PpcFilter.getInstance().setIsPrequal(true);

			this._applyFilters(() => {
				prequalifySpinner.hide();
			});

			this._hidePopup();
			this._questionStorage.setIsQuestionDone();
		}, 500);
	}

	_goToPrevQuestion() {
		const prevQuestion = this._questionStorage.getLastPrevQuestion();

		if (!prevQuestion) {
			return;
		}

		const prevQuestionStorage = this._questionStorage;

		this._questionStorage = QuestionStorageBuilder.buildByPageIdAndDataForQuestion(
			this._questionStorage.pageId, this._questionStorage, prevQuestion
		);

		prevQuestionStorage.removeFromStorage();

		this._handleCurrentQuestion();
	}

	_sendPrequal_step_0_BIEvent(questionId) {
		if (this._step_0_eventWasSent) {
			return;
		}

		Alooma.aloomaSendEvent('prequal_event', {
			pageview_id: Alooma.aloomaPageData.pageview_id,
			prequal: {
				step: 'step_0',
			},
		});

		this._step_0_eventWasSent = true;

		$(document).trigger('PrequalifyModalHandler:prequalShown');
	}

	_sendPrequalAnswerBIEvent(questionId, answer, step) {
		if (!answer || !step) {
			return;
		}
		Alooma.aloomaSendEvent('prequal_event', {
			pageview_id: Alooma.aloomaPageData.pageview_id,
			prequal: {
				step: 'step_' + step,
				question: questionId,
				answer: answer,
			},
		});
	}

	_hidePodiumIfNeeded() {
		const $podium = $('.podium');
		const $podiumVendors = $podium.find('.vendors-data-holder .vendor-data');

		if (!$podiumVendors.length) {
			return;
		}

		const podiumVendorIds = this._getVendorIds($podiumVendors);
		const vendorsListIds = this._getVendorIds($('.vendors-list .ppc-single-vendor'));

		if ($('.vendors-list .ppc-single-vendor.visibly-hidden').length) {
			return;
		}

		for (const podiumVendorId of podiumVendorIds) {
			if (!vendorsListIds.includes(podiumVendorId)) {
				$podium.addClass('hidden');
				break;
			}
		}
	}

	_getVendorIds($vendors) {
		const vendorIds = [];

		$vendors.each((i, vendor) => {
			const $vendor = $(vendor);

			if (!$vendor.hasClass('hidden')) {
				vendorIds.push(+$vendor.data('vendor-id'));
			}
		});

		return vendorIds;
	}
}

export default PrequalifyModalHandler;
